import './switch'; // THIS MUST BE FIRST - it runs the code to set window.MY_SWITCH
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import AppRoutes from './AppRoutes'; // Import the main controller for frontend testing
import App from './App';  //import the main controller for backend testing
import AppMaster from './AppMaster';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// <AppRoutes/> === Frontend stuff is being looked at here
// <App/> === Backend stuff is being looked at here
// swap between these two to test either side.
root.render(
  <React.StrictMode>
    <AppMaster/>
  </React.StrictMode>
);

reportWebVitals();